var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.socialComputed)?_c('nav-list',{attrs:{"nav":_vm.socialComputed,"_class":'-circle -border-main'}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }